// extracted by mini-css-extract-plugin
export default {"menu-name":"menu_menu-name__mctuk","choosed":"menu_choosed__liaaD"};